import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from '../services/shared-data.service';
import { Location } from '@angular/common';
import { ActiveJobs } from '../domain/activeJobs';
import { JobLog } from '../domain/JobLog';

@Component({
    selector: 'app-joblogview',
    templateUrl: './joblogview.component.html',
    styleUrls: ['./joblogview.component.css'],
    standalone: false
})
export class JoblogviewComponent implements OnInit {

  avtiveJobLog: ActiveJobs;

  joblogs: JobLog[];

  constructor(private route: Router, private loc_pos: Location, private sharedDataService: SharedDataService) {
    this.avtiveJobLog = sharedDataService.rowData
    this.joblogs = sharedDataService.joblogs;
  }

  ngOnInit() {
    if (this.sharedDataService.rowData == null)
    this.loc_pos.back();
  }

  goBack() {
    this.sharedDataService.returnHome();
    // goes back to last router location
    this.loc_pos.back();
  }

  download() {
    setTimeout(() => {
      let csvData = "";
      let msg1 = '';
      let msg2 ='';
      for (let log of this.joblogs) {
        if(log.messageText != null && log.messageText != undefined && log.messageText!= 'null')
                msg1 = log.messageText;
       if(log.messageSecondLevelText != null && log.messageSecondLevelText != undefined && log.messageSecondLevelText!= 'null')
                msg2 = "\r\t" +log.messageSecondLevelText;

       csvData += msg1+"\n" + msg2;
       msg1 = '';
       msg2 ='';
      }
      let a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      let blob = new Blob([csvData], { type: 'application/octet-stream' });
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      let x: Date = new Date();
      // File name
      let link: string = this.avtiveJobLog.jobName + "_" 
                        + this.avtiveJobLog.jobUser + "_" 
                        + this.avtiveJobLog.jobNumber + "_" 
                        + x.getMonth() + "_" 
                        + x.getDate() + "_" 
                        + x.getFullYear() + "_" 
                        + x.getHours() + "_" 
                        + x.getMinutes() + "_" 
                        + x.getSeconds() + '.log';
                        
      a.download = link.toLocaleLowerCase();
      a.click();
    });
  }
}
